/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Panel.css'); }
exports.Panel = function Panel(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return React.createElement("div", { className: classnames("m-panel", className) }, children);
};
exports.PanelGroup = function PanelGroup(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("div", { className: classnames("m-panelGroup", className) }, children));
};
exports.PanelHeader = function PanelHeader(_a) {
    var title = _a.title, _b = _a.centeredContent, centeredContent = _b === void 0 ? false : _b, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["title", "centeredContent", "children", "className"]);
    return (React.createElement("div", { className: classnames("m-panel-header", className, centeredContent ? "m-panel-headerCenteredContent" : "") },
        !!title && React.createElement("span", { className: "m-panel-header" }, title),
        children));
};
exports.PanelContent = function PanelContent(_a) {
    var children = _a.children, className = _a.className, _b = _a.padded, padded = _b === void 0 ? true : _b, props = tslib_1.__rest(_a, ["children", "className", "padded"]);
    return (React.createElement("div", { className: classnames(className, "m-panel-content", padded ? "m-panel-contentPadding" : "") }, children));
};
exports.PanelFooter = function PanelFooter(_a) {
    var children = _a.children, className = _a.className, stack = _a.stack, props = tslib_1.__rest(_a, ["children", "className", "stack"]);
    return (React.createElement("div", { className: classnames("m-panel-footer", stack ? "m-panel-footer-isStack" : "", className) }, children));
};
exports.Panel.propTypes = {
    className: PropTypes.string
};
exports.PanelHeader.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    centeredContent: PropTypes.bool
};
exports.PanelContent.propTypes = {
    className: PropTypes.string
};
exports.PanelContent.defaultProps = {
    padded: true
};
exports.PanelFooter.propTypes = {
    className: PropTypes.string,
    stack: PropTypes.bool
};